<template>
  <div class="container">
    <o-bread-crumb>
      <template v-slot:pageName>
        Corporate
      </template>
      <template v-slot:pageDetail>
        Member Tier
      </template>
    </o-bread-crumb>
    <div class="card text-center bg-white shadow-none">
      <div class="card-header">
        <ul class="nav nav-pills card-header-pills flex-column flex-md-row justify-content-between ms-2 me-4 mt-2 mb-2 gap-3 gap-md-0">
          <li class="nav-item text-start">
            <div class="d-flex d-inline-block">
              <h4 class="header-title mb-0">
                  <i class="fas fa-layer-group me-2 primary-icon"></i>List of Member Tiers
              </h4>
            </div>
            <p class="header-subtitle mt-1 mb-0">Manage member tiers settings</p>
          </li>
          <li class="nav-item d-flex flex-wrap align-items-center justify-content-start justify-content-md-end gap-2">
            <template v-if="writeTierDuration && thisTierDurationShow">
              <router-link v-if="thisTierShow && write" :to="{ name: 'ThresholdSettings' }" class="btn btn-action-secondary mt-1 mt-md-0" :class="{ 'btn-locked': !isThresholdSettingEnabled }">
                  <i :class="isThresholdSettingEnabled ? 'fas fa-cog me-1' : 'fas fa-lock me-1 btn-lock-icon'"></i> Threshold Settings
              </router-link>
              <button v-if="durationStatus.status"
                @click="editModalDuration(durationStatus.corporate_id, durationStatus.expiration)"
                class="btn btn-action-secondary mt-1 mt-md-0">
                <i class="fas fa-clock me-2"></i> Update Duration
              </button>
              <button v-else @click="showModalDuration"
                class="btn btn-action-secondary mt-1 mt-md-0">
                <i class="fas fa-clock me-2"></i> Set Duration
              </button>
            </template>
            <div v-if="thisTierDurationShow" class="duration-status-container m-0 ms-3">
              <div v-if="durationStatus.status" class="modern-status-badge success-status">
                <div class="status-icon-wrapper ms-2">
                  <i class="fas fa-clock"></i>
                </div>
                <div class="status-details">
                  <span class="status-label">Current Duration</span>
                  <span class="status-value">{{ expiration(durationStatus.expiration) }}</span>
                </div>
                <div class="status-pulse-dot"></div>
              </div>
              <div v-else class="modern-status-badge warning-status">
                 <div class="status-icon-wrapper ms-2">
                   <i class="fas fa-exclamation-triangle"></i>
                 </div>
                 <div class="status-details">
                   <span class="status-label">Action Required</span>
                   <span class="status-value">Set duration to apply tiering!</span>
                 </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="spinner d-flex justify-content-center align-items-center" v-if="page.isLoading">
          <div class="spinner-border text-primary" role="status"></div>
        </div>

        <div v-if="page.output">
          <div class="filter-action-wrapper mb-4 mt-3">
              <div class="filter-controls">
                  <!-- Search Control -->
                  <div class="search-box-custom">
                      <div class="search-type-tabs">
                          <button class="tab-btn active">
                              Tier Name
                          </button>
                      </div>
                      <div class="search-input-wrapper">
                          <input 
                              type="text" 
                              class="form-control-search" 
                              v-model="searchCriteria" 
                              placeholder="Search..." 
                              @keyup.enter="doSearch()" 
                          />
                          <button v-if="!isSearchActive" class="btn-search" @click="doSearch()">
                              <i class="fas fa-search"></i>
                          </button>
                          <button v-else class="btn-search" @click="clearSearch()">
                              <i class="fas fa-times text-danger"></i>
                          </button>
                      </div>
                  </div>
              </div>

              <div class="action-section">
                  <div class="action-buttons-group">
                      <button class="btn btn-refresh" @click.prevent="resetState()" title="Refresh">
                          <i class="fas fa-sync-alt"></i>
                      </button>
                      <button v-if="write" @click="recalculate" class="btn btn-action-secondary" title="Sync">
                          <i class="fas fa-retweet me-2"></i> Sync
                      </button>

                      <button v-if="thisTierShow && write && isEmptyMemberTier" @click="generate" class="btn btn-action-secondary">
                          <i class="fas fa-magic me-2"></i> Create from Template
                      </button>
                      <button v-if="thisTierShow && write" @click="showModal" class="btn btn-add">
                          <i class="fas fa-plus me-2"></i> Add New Tier
                      </button>
                  </div>
              </div>
          </div>


          <o-table v-if="thisTierShow" style="text-align:left;" class="table-hover member-list-table">
            <thead>
              <tr v-if="fields">
                <th class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                  {{ field }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in MemberTier" :key="item.id" class="member-row-clickable">
                <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ formatCurrency(item.transaction_value_min) }}</td>
                <td>{{ item.transaction_max !== null ? '&lt; ' + formatCurrency(item.transaction_max) : '> ' +
                  formatCurrency(item.transaction_value_min) }}</td>
                <td>{{ item.member_tier_count ? item.member_tier_count : 0 }}</td>
                <td class="ml-3">
                  <div class="d-flex gap-2" @click.stop>
                      <button v-if="write" class="btn btn-action btn-edit"
                        @click="editModal(item.id, item.name, item.transaction_value_min, item)">
                        <i class="fas fa-edit me-1"></i> Edit
                      </button>
                      <router-link class="btn btn-action btn-info-action" :to="{ name: 'ShowMemberTier', params: { id: item.id } }">
                        <i class="fas fa-users me-1"></i> Members
                      </router-link>
                      <button v-if="write" class="btn btn-action btn-delete"
                        @click.prevent="destroy(item.id, item.name)">
                        <i class="fas fa-trash-alt me-1"></i> Delete
                      </button>
                  </div>
                </td>
              </tr>
              <tr v-if="MemberTier.length === 0">
                <td colspan="7" class="text-center">No member tiers available</td>
              </tr>
            </tbody>
          </o-table>
        </div>
      </div>
      <div class="container mt-5">
        <o-pagination :page="meta.page" :total="meta.total" @callback="navPage" />
      </div>
    </div>
  </div>
  <member-tier-detail v-if="isModalVisible" @parentAddItem="saveDetail" @parentCloseModal="closeModal"
    :editedItem="editedItem">
  </member-tier-detail>
  <member-tier-duration v-if="isModalVisibleDuration" @parentAddItem="saveDetailDuration"
    @parentCloseModal="closeModalDuration" :editedItemDuration="editedItemDuration">
  </member-tier-duration>

  <!-- Delete Confirmation Modal -->
  <o-warning-box
      v-if="isDeleteConfirmationVisible"
      title="Confirm Delete"
      :item-name="tierToDeleteName"
      warning-message="This action cannot be undone and may affect members currently in this tier."
      confirm-text="Delete"
      :is-loading="page.isLoading"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
      :hide-action="false"
  />
</template>

<script>
import { OBreadCrumb, OTable, OPagination, OWarningBox } from '@/components/OmnihControl';
import { mapState } from 'vuex';
import { computed, onMounted, reactive, ref, watch, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MemberTierDetail from './membertier/MemberTierDetail.vue';
import MemberTierDuration from './membertier/MemberTierDuration.vue';
import store from '@/store/';
import { useToast } from '@/composables/useToast';

export default {
  components: {
    OTable,
    OPagination,
    OBreadCrumb,
    MemberTierDetail,
    MemberTierDuration,
    OWarningBox
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { showToast } = useToast();
    let lastActivePage = 1;

    const page = reactive({
      isLoading: false,
      output: false,
      component: 'member-tier',
      component2: 'tier-duration'
    });

    const selfLoaded = ref(store.state.Auth.selfLoaded);

    watch(
      () => store.state.Auth.selfLoaded,
      (newVal) => {
        if (newVal) {
          selfLoaded.value = newVal;
          load_state();
        }
      }
    );

    onMounted(() => {
      store.commit('MemberTier/reset_meta');

      if (selfLoaded.value) {
        store.commit('Member/reset_meta');
        load_state();
      }

      // Check if redirected from create member tier page
      if (route.query.newMemberTier === 'true') {
        store.dispatch('MemberTier/read').then(() => {
          const lastPage = meta.value.total;
          if (lastPage > 1 && meta.value.page !== lastPage) {
            const newMeta = { ...meta.value, page: lastPage };
            store.commit('MemberTier/switch_page', { meta: newMeta });
            store.dispatch('MemberTier/read');
          }
          router.replace({ name: 'MemberTier' });
        });
      }
    });

    onBeforeUnmount(() => {
      const updatedMeta = { ...meta.value, page: lastActivePage };
      store.commit('MemberTier/switch_page', { meta: updatedMeta });

      store.commit('MemberTier/clear_search');
      store.dispatch('MemberTier/read').then(() => { });
    });

    const isExpanded = reactive({
      before: [],
      after: []
    });
    let fields = ref([
      'No',
      'Tier Name',
      'Transaction Minimum Value',
      'Transaction Maximum Value',
      'Total Member',
      'Actions'
    ]);

    const MemberTiersSearch = ref([]);

    const write = ref(false);
    const writeTierDuration = ref(false);
    const error = ref(null);
    const success = ref(null);
    const visible = ref(false);
    const durationStatus = reactive({
      status: false,
      expiration: 0
    })

    const searchCriteria = ref('');
    const isSearchActive = ref(false);
    // delete confirmation
    const isDeleteConfirmationVisible = ref(false);
    const tierToDeleteId = ref(null);
    const tierToDeleteName = ref('');

    let meta = computed(() => store.state.MemberTier.meta);

    const expiration = (expiration) => {
      const expiration_month = Math.floor(Number(expiration) / 2592000);
      const expiration_day = Math.floor((Number(expiration) - (expiration_month * 2592000)) / 86400);

      return `${expiration_month} Month, ${expiration_day} Day`;
    };

    const thisTierDurationShow = ref(true);
    const thisTierShow = ref(true);

    const isModalVisible = ref(false);
    const isModalVisibleDuration = ref(false);
    const editedItem = ref({
      id: '',
      name: '',
      transaction_value_min: '',
      title: '',
      icon: ''
    });

    const editedItemDuration = ref({
      corporate_id: '',
      expiration: 0
    });

    const isEmptyMemberTier = computed(() => {
      return store.state.MemberTier.meta.cek_tiers === 0;
    });

    // Check if threshold setting is enabled via feature flag
    const isThresholdSettingEnabled = computed(() => {
      return (store.state.FeatureFlag?.thresholdSetting?.flag || 'ACTIVE') === 'ACTIVE'
    });

    function showModal() {
      editedItem.value = {};
      isModalVisible.value = true;
    }

    function showModalDuration() {
      editedItemDuration.value = {};
      isModalVisibleDuration.value = true;
    }

    function closeModal() {
      isModalVisible.value = false;
    }

    function closeModalDuration() {
      isModalVisibleDuration.value = false;
    }

    function saveDetail(dataDariChild) {
      dataDariChild.transaction_value_min = dataDariChild.transaction_value_min.split('.').join("");
      page.isLoading = true;

      store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
        dataDariChild.corporate_id = businessProfile.corporate_id;

        if (dataDariChild.title === 'Edit Member Tier') {
          store.dispatch('MemberTier/update', { data: dataDariChild })
            .then(() => {
              showToast({ type: 'success', title: 'Success', message: 'Member tier updated successfully.' });
              load_state();
            })
            .catch((err) => {
              showToast({ type: 'error', title: 'Error', message: err.response?.data?.message || err.message });
              console.error('Error updating Member Tier:', err);
            })
            .finally(() => {
              page.isLoading = false;
              isModalVisible.value = false;
            });
        } else {
          store.dispatch('MemberTier/create', { data: dataDariChild })
            .then(() => {
              showToast({ type: 'success', title: 'Success', message: 'Member tier created successfully.' });
              store.dispatch('MemberTier/read').then(() => {
                const lastPage = meta.value.total;
                if (lastPage > 1 && meta.value.page !== lastPage) {
                  const newMeta = { ...meta.value, page: lastPage };
                  store.commit('MemberTier/switch_page', { meta: newMeta });
                  load_state();
                } else {
                  load_state();
                }
              });
            })
            .catch((err) => {
              if (err.response?.data?.error?.includes('already exists')) {
                page.isLoading = false;
                isModalVisible.value = true;
                showToast({ type: 'error', title: 'Error', message: err.response.data.error });
              } else {
                showToast({ type: 'error', title: 'Error', message: err.response?.data?.message || err.message });
                console.error('Error creating Member Tier:', err);
              }
            })
        }
      }).catch((err) => {
        showToast({ type: 'error', title: 'Error', message: 'Failed to fetch business profile.' });
        console.error('Error fetching business profile:', err);
        page.isLoading = false;
        isModalVisible.value = false;
      }).finally(() => {
        isModalVisible.value = false;
      });
    }

    function saveDetailDuration(dataDariChild) {
      page.isLoading = true;

      store.dispatch('Auth/getBusinessProfile')
        .then((businessProfile) => {
          dataDariChild.corporate_id = businessProfile.corporate_id;

          const actionType = dataDariChild.title === 'Edit Member Tier Duration'
            ? 'membertierDuration/update'
            : 'membertierDuration/create';

          store.dispatch(actionType, { data: dataDariChild })
            .then(() => {
              showToast({ type: 'success', title: 'Success', message: 'Duration saved successfully.' });
              load_state();
            })
            .catch((err) => {
              showToast({ type: 'error', title: 'Error', message: err.response?.data?.message || err.message });
              console.error('Error processing Member Tier Duration:', err);
            })
            .finally(() => {
              page.isLoading = false;
              isModalVisibleDuration.value = false;
            });
        })
        .catch((err) => {
          showToast({ type: 'error', title: 'Error', message: 'Failed to fetch business profile.' });
          console.error('Error fetching business profile:', err);
          page.isLoading = false;
          isModalVisibleDuration.value = false;
        });
    }

    function editModalDuration(corporate_id, expiration) {
      editedItemDuration.value = {
        corporate_id: corporate_id,
        expiration: expiration
      };
      isModalVisibleDuration.value = true;
    }

    function editModal(id, name, min, item) {
      const minValue = Math.floor(Number(min));
      editedItem.value = {
        id: id,
        name: name,
        transaction_value_min: minValue,
        item: item,
        title: 'Edit Value'
      };
      isModalVisible.value = true;
    }

    function formatCurrency(value) {
      if (!value) return '0.00';
      const formattedValue = parseFloat(value).toFixed(2);
      return formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    function generate() {
      page.isLoading = true;

      store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
        const corporate_id = businessProfile.corporate_id;
        const tiers = [
          { name: 'Gold', transaction_value_min: '100000', corporate_id, icon: 'no icon' },
          { name: 'Platinum', transaction_value_min: '2000000', corporate_id, icon: 'no icon' },
          { name: 'Diamond', transaction_value_min: '5000000', corporate_id, icon: 'no icon' },
        ];

        const promises = tiers.map(tier =>
          store.dispatch('MemberTier/create', { data: tier })
        );

        Promise.all(promises)
          .then(() => {
            showToast({ type: 'success', title: 'Success', message: 'Member Tiers template applied successfully.' });
            load_state();
          })
          .catch((err) => {
            showToast({ type: 'error', title: 'Error', message: 'Failed to create Member Tier from template.' });
            console.error('Error creating Member Tier from template:', err);
          })
          .finally(() => {
            page.isLoading = false;
          });
      }).catch((err) => {
        showToast({ type: 'error', title: 'Error', message: 'Failed to fetch business profile.' });
        console.error('Error fetching business profile:', err);
        page.isLoading = false;
      });
    }

    function load_state() {
      page.isLoading = true;
      visible.value = false;
      success.value = null;
      error.value = null;

      store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
        const filter = {
          corporate_id: businessProfile.corporate_id
        }
        store.dispatch('membertierDuration/checkDuration', businessProfile.corporate_id)
          .then((result) => {
            if (result.status == true) {
              durationStatus.status = true;
              durationStatus.expiration = result.expiration;
              durationStatus.corporate_id = businessProfile.corporate_id;
            } else {
              durationStatus.status = false;
            }
          })
          .catch((err) => {
            thisTierDurationShow.value = false;
            console.error(err);
          });

        store.commit('MemberTier/add_filter', { filter });

        store.dispatch('MemberTier/read')
          .catch((err) => {
            console.log(err);
            thisTierShow.value = false;
          })
          .finally(() => {
            page.isLoading = false
            page.output = true
          });
        if (store.state.Auth.currUser.level === 'root') {
          write.value = true;
          writeTierDuration.value = true;
        } else {
          const userModules = store.state.Auth.userInfo.modules;

          if (userModules) {
            const matchingModule = userModules.find(module => module.module_name === page.component);
            write.value = matchingModule ? matchingModule.write : false;

            const tierDurationModule = userModules.find(module => module.module_name === page.component2);
            writeTierDuration.value = tierDurationModule ? tierDurationModule.write : false;
          } else {
            console.error('userModules is undefined');
            write.value = false;
          }
        }
      });
    }

    function recalculate() {
      page.isLoading = true;

      store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
        const filter = {
          corporate_id: businessProfile.corporate_id
        }
        store.dispatch('MemberTiering/recalculate', businessProfile.corporate_id)
          .then(() => {
            // console.log(result,'checking');
          })
          .catch((err) => {
            console.error(err);
            showToast({ type: 'error', title: 'Error', message: err.message });
          })
          .finally(() => {
            page.isLoading = false;
            showToast({ type: 'success', title: 'Success', message: 'Recalculate has been succeded.' });
          });

        store.commit('MemberTier/add_filter', { filter });

        store.dispatch('MemberTier/read')
          .catch((err) => console.error(err))
          .finally(() => {
            page.isLoading = false
            page.output = true
          });
      });
    }

    function destroy(id, name) {
      tierToDeleteId.value = id;
      tierToDeleteName.value = name;
      isDeleteConfirmationVisible.value = true;
    }

    function confirmDelete() {
      page.isLoading = true;
      
      store.dispatch('MemberTier/delete', tierToDeleteId.value)
        .then(() => {
          showToast({ type: 'success', title: 'Success', message: 'Member tier deleted successfully.' });
          load_state();
        }).catch((err) => {
          showToast({ type: 'error', title: 'Error', message: err.message });
          console.error(err);
        }).finally(() => {
          page.isLoading = false;
          isDeleteConfirmationVisible.value = false;
          tierToDeleteId.value = null;
          tierToDeleteName.value = '';
        });
    }

    function cancelDelete() {
      isDeleteConfirmationVisible.value = false;
      tierToDeleteId.value = null;
      tierToDeleteName.value = '';
    }

    function navPage(pageNumber) {
      const updatedMeta = { ...meta.value, page: pageNumber };

      store.commit('MemberTier/switch_page', { meta: updatedMeta });
      load_state();
    }

    function doSearch() {
      if (searchCriteria.value) {
        let search = { 'tier name': searchCriteria.value };
        
        isSearchActive.value = true;
        
        if (meta.value.page !== 1) {
            lastActivePage = meta.value.page;
            const updatedMeta = { ...meta.value, page: 1 };
            store.commit('MemberTier/switch_page', { meta: updatedMeta });
            store.commit('MemberTier/set_search', { search });
            store.dispatch('MemberTier/read').then(response => {
                MemberTiersSearch.value = response.data;
                isExpanded.before = Array(response.data.length).fill(false);
                isExpanded.after = Array(response.data.length).fill(false);
            });
        } else {
            store.commit('MemberTier/set_search', { search });
            store.dispatch('MemberTier/read').then(response => {
                MemberTiersSearch.value = response.data;
                isExpanded.before = Array(response.data.length).fill(false);
                isExpanded.after = Array(response.data.length).fill(false);
            });
        }
      }
    }

    function clearSearch() {
      isSearchActive.value = false;
      searchCriteria.value = '';

      const updatedMeta = { ...meta.value, page: lastActivePage };
      store.commit('MemberTier/switch_page', { meta: updatedMeta });

      store.commit('MemberTier/clear_search');
      store.dispatch('MemberTier/read').then(response => {
          isExpanded.before = Array(response.data.length).fill(false);
          isExpanded.after = Array(response.data.length).fill(false);
      });
    }

    function resetState() {
      searchCriteria.value = '';
      isSearchActive.value = false;

      store.commit('MemberTier/clear_search');
      const updatedMeta = { ...meta.value, page: 1 };
      store.commit('MemberTier/switch_page', { meta: updatedMeta });
      load_state();
    }

    function formatJson(jsonData) {
      if (!jsonData) return '';
      const test = JSON.parse(jsonData);
      return JSON.stringify(test, null, 2);
    }

    function collapsedJson(jsonData) {
      if (!jsonData) return '';
      const test = JSON.parse(jsonData);
      return JSON.stringify(test, null, 2).slice(0, 2) + '...';
    }

    function toggle(index, type) {
      isExpanded[type][index] = !isExpanded[type][index];
    }

    function formatDate(date) {
      const newDate = new Date(date);

      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC'
      };

      const datePart = newDate.toLocaleDateString('en-US', options).split(', ');

      const formattedDate = `${datePart[0]} on ${datePart[1]} ${datePart[2]}`;

      return formattedDate;
    }

    function shortenUserId(userId) {
      if (!userId) return '';
      return userId.slice(0, 5) + '...';
    }

    function showAlert() {
      visible.value = true;
      // setTimeout(() => {
      //   visible.value = false;
      //   success.value = null;
      //   error.value = null;
      // }, 5000);
    }

    watch(error, (newValue) => {
      if (newValue) {
        showAlert();
      }
    });

    watch(success, (newValue) => {
      if (newValue) {
        showAlert();
      }
    });

    return {
      page,
      searchCriteria,
      isSearchActive,
      meta,
      fields,
      load_state,
      navPage,
      doSearch,
      clearSearch,
      resetState,
      showModal,
      showModalDuration,
      formatJson,
      formatDate,
      toggle,
      isExpanded,
      collapsedJson,
      shortenUserId,
      formatCurrency,
      destroy,
      closeModal,
      closeModalDuration,
      saveDetail,
      saveDetailDuration,
      editModal,
      editModalDuration,
      isModalVisible,
      isModalVisibleDuration,
      editedItem,
      editedItemDuration,
      generate,
      isEmptyMemberTier,
      error,
      durationStatus,
      recalculate,
      expiration,
      success,
      visible,
      watch,
      thisTierDurationShow,
      thisTierShow,
      selfLoaded,
      write,
      writeTierDuration,
      isDeleteConfirmationVisible,
      tierToDeleteName,
      confirmDelete,
      cancelDelete,
      isThresholdSettingEnabled
    };
  },
  computed: {
    ...mapState({
      MemberTier: state => state.MemberTier.MemberTier
    }),
  },
};
</script>

<style scoped>
.container {
  overflow-x: auto;
}

.table th,
.table td {
  word-wrap: break-word;
  white-space: normal;
}

.form-group {
  width: 250px;
  text-align: left;
  padding-left: 16px;
}

.json-viewer pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  cursor: pointer;
  color: black;
}

.json-viewer span {
  cursor: pointer;
  color: black;
}

.json-viewer button {
  margin-left: 10px;
  cursor: pointer;
  background: none;
  border: none;
  color: black;
}

.nav-item .btn {
  margin-left: 1.0rem;
}

.btn-custom {
  min-width: 150px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  text-align: center;
}

.btn-locked {
  opacity: 0.55;
  cursor: pointer !important;
  pointer-events: all !important;
  transition: opacity 0.2s ease;
}

.btn-lock-icon {
  color: var(--primary-color, #f39c12);
}

.nav-link {
  padding: 0.375rem 0.75rem;
}

.link-wrapper {
  margin-bottom: 10px;
}

.nav-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.add-member-tier-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.duration-status-container {
  display: flex;
  justify-content: flex-start;
  margin-left: 1.0rem;
}

.modern-status-badge {
  display: inline-flex;
  align-items: center;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 4px 16px 4px 4px;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.status-icon-wrapper {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 13px;
}

.success-status .status-icon-wrapper {
  background-color: #dcfce7;
  color: #166534;
}

.warning-status {
  border-color: #fecaca;
  background-color: #fff5f5;
}

.warning-status .status-icon-wrapper {
  background-color: #fee2e2;
  color: #991b1b;
}

.status-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 16px;
  text-align: left;
}

.status-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  font-weight: 600;
  line-height: 1.2;
}

.warning-status .status-label {
  color: #991b1b;
}

.status-value {
  font-size: 14px;
  color: #0f172a;
  font-weight: 600;
}

.warning-status .status-value {
  color: #7f1d1d;
}

.status-pulse-dot {
  width: 12px;
  height: 12px;
  background-color: #22c55e;
  border-radius: 50%;
  margin-left: auto;
  position: relative;
}

.status-pulse-dot::after {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 50%;
  border: 2px solid #22c55e;
  opacity: 0;
  animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

@keyframes pulse-ring {
  0% { transform: scale(0.8); opacity: 0.5; }
  80%, 100% { transform: scale(1.5); opacity: 0; }
}

/* Styling from Member.vue for consistency */
.filter-action-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.filter-controls {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

.search-box-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: max-content;
}

.search-type-tabs {
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
    flex-wrap: wrap;
}

.tab-btn {
    border: none;
    background: transparent;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
}

.tab-btn.active {
    background: white;
    color: var(--primary-color, #0d6efd);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-weight: 600;
}

.search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0;
    transition: all 0.2s;
    overflow: hidden;
}

.search-input-wrapper:focus-within {
    border-color: var(--primary-color, #0d6efd);
    box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
}

.search-input-wrapper input {
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
    box-shadow: none;
}

.btn-search {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.btn-search:hover {
    background: #e2e8f0;
    color: var(--primary-color, #0d6efd);
}

.search-input-wrapper .btn-search {
    position: relative;
    width: 44px;
    height: 42px;
    border-radius: 0;
    background: transparent;
}

.search-input-wrapper .btn-search:hover {
    background: #f1f5f9;
}

.search-input-wrapper .btn-search::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1.1px;
    height: 60%;
    background: linear-gradient(to bottom, rgba(203, 213, 225, 0), rgba(203, 213, 225, 1), rgba(203, 213, 225, 0));
    pointer-events: none;
}

.action-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.action-buttons-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-refresh {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 8px;
}

.btn-refresh:hover {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
}

.btn-action-secondary {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 13px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
    cursor: pointer;
}

.btn-action-secondary:hover {
    background-color: #e2e8f0;
    color: #1e293b;
}

.btn-add {
    background-color: var(--primary-color, #0d6efd);
    color: white;
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: none;
    border-radius: 8px;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-add:hover {
    filter: brightness(0.9);
    color: white;
}

.member-list-table {
    white-space: nowrap;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
}

.member-list-table th,
.member-list-table td {
    padding: 12px 16px !important;
    vertical-align: middle;
}

.member-row-clickable {
    transition: background-color 0.2s;
}

.member-row-clickable:hover {
    background-color: #f8fafc !important;
}

.btn-action {
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
}

.btn-info-action {
    background-color: #eff6ff;
    color: #1e40af;
}

.btn-info-action:hover {
    background-color: #dbeafe;
    color: #1e3a8a;
}

.btn-edit {
    background-color: #f3f4f6;
    color: #374151;
}

.btn-edit:hover {
    background-color: #e5e7eb;
    color: #111827;
}

.btn-delete {
    background-color: #fff1f2;
    color: #9f1239;
}

.btn-delete:hover {
    background-color: #ffe4e6;
    color: #be123c;
}

.header-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    display: flex;
    align-items: center;
}

.header-subtitle {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    text-align: left;
}
</style>